import {
  Button,
  Grid,
  makeStyles,
  SwipeableDrawer,
  Tab,
  Tabs,
} from '@material-ui/core';
import React, { useState } from 'react';
import AddIcon from '@material-ui/icons/Add';
import WarehousesTable from './Warehouses/WarehousesTable';
import AddWarehouse from './Warehouses/AddWarehouse';
import BackDropLoading from '../../common/models/BackDrop';
import EditWarehouseDetails from './ViewEditWarehouses/EditWarehouseDetails';

const useStyles = makeStyles((theme) => ({
  upload: {
    background:
      'transparent linear-gradient(251deg, #173072 0%, #301232 100%) 0% 0% no-repeat padding-box;',
    color: 'white',
    textTransform: 'none',
    borderRadius: '2rem',
    padding: '5px 20px',
    '&:hover': {
      backgroundColor: 'green',
      background: 'green',
      color: 'white',
    },
  },
}));

const SitesAndResources = () => {
  const classes = useStyles();
  const [tabIndex, setTabIndex] = useState('Warehouses');
  const [buttonOpen, setButtonOpen] = useState({
    addWarehouse: false,
  });

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleButton = (type) => {
    if (type === 'Warehouses') {
      setButtonOpen({
        ...buttonOpen,
        addWarehouse: !buttonOpen.addWarehouse,
      });
    }
  };

  const tabsData = [
    {
      label: 'Warehouses',
    },
  ];

  return (
    <React.Fragment>
      <Grid container spacing={3}>
        {/* Tabs Section */}
        <Grid item xs={9}>
          {/* <AppBar position='static' color='default'> */}
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            indicatorColor='secondary'
            textColor='secondary'
            variant='scrollable'
            scrollButtons='auto'
          >
            {tabsData.map((tab, index) => (
              <Tab
                key={tab.label || index}
                label={tab.label}
                value={tab.label}
                style={{ textTransform: 'none' }}
              />
            ))}
          </Tabs>
          {/* </AppBar> */}
        </Grid>

        {/* Button Section */}
        <Grid
          item
          xs={3}
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          <Button
            startIcon={<AddIcon />}
            onClick={() => {
              handleButton('Warehouses');
            }}
            className={classes.upload}
          >
            Add new warehouse
          </Button>
        </Grid>
      </Grid>
      {tabIndex === 'Warehouses' && <WarehousesTable />}

      <SwipeableDrawer
        anchor={'right'}
        open={buttonOpen.addWarehouse}
        // onClose={() => handleButton('Warehouses')}
        onOpen={() => handleButton('Warehouses')}
      >
        <BackDropLoading />
        <AddWarehouse handleClose={() => handleButton('Warehouses')} />
        
      </SwipeableDrawer>
    </React.Fragment>
  );
};

export default SitesAndResources;
